import { z } from 'zod';

export const QuoteSettingsSchema = z.object({
  preprocessQuotesConfidenceThreshold: z
    .number()
    .min(0)
    .max(1)
    .nullable()
    .optional(),
  enableSwapQuoteOwners: z.boolean().optional().nullable(),
  autoReassignQuoteOwner: z.boolean().optional().nullable(),
  skipEmailRateReconciliation: z.boolean().optional().nullable(),
  staleQuotesConsideredLost: z.number().int().positive().nullable().optional(),
});

export type QuoteSettings = z.infer<typeof QuoteSettingsSchema>;
